<template>
    <div class="bg-white py-18 px-4 overflow-hidden font-poppins antialiased">
  <!-- Scrollable client showcase -->
  <div class="max-w-full mx-auto lg:px-12">
    <h2 class="text-3xl md:text-4xl font-semibold text-gray-800 text-center mb-2">
      Our Clients
    </h2>
    <p class="text-gray-600 text-center text-sm mb-12 max-w-2xl mx-auto">
      Trusted by leading companies around the world
    </p>
    
    <!-- Client logos carousel -->
    <div class="relative overflow-hidden">
      <!-- Gradient overlay for smooth fade effect -->
      <div class="absolute left-0 top-0 h-full w-16 bg-gradient-to-r from-gray-50 to-transparent z-10"></div>
      <div class="absolute right-0 top-0 h-full w-16 bg-gradient-to-l from-gray-50 to-transparent z-10"></div>
      
      <div class="overflow-hidden w-full pb-2">
        <div class="flex items-center space-x-1 w-max animate-scroll">
          <!-- Client Cards - first set -->
          <div 
            v-for="(client, index) in clients"
            :key="`first-${index}`"
            class="flex-shrink-0 flex items-center justify-center p-4">
            <img 
              :src="require(`@/assets/${client.image}`)" 
              :alt="client.name" 
              class="h-auto w-auto max-h-80 max-w-40 object-contain" />
          </div>
          
          <!-- Client Cards - duplicate set for continuous scrolling -->
          <div 
            v-for="(client, index) in clients"
            :key="`second-${index}`"
            class="flex-shrink-0 flex items-center justify-center p-4">
            <img 
              :src="require(`@/assets/${client.image}`)" 
              :alt="client.name" 
              class="h-auto w-auto max-h-80 max-w-40 object-contain" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      clients: [
        { id: 1, name: 'Client 1', image: 'logo vgroup.png' },
        { id: 2, name: 'Client 2', image: 'logo bca.png' },
        { id: 3, name: 'Client 3', image: 'logo suzuya.png' },
        { id: 17, name: 'Client 4', image: 'logo coffe crowd.png' },
        { id: 4, name: 'Client 5', image: 'logo yayasan baitul maal.png' },
        { id: 5, name: 'Client 6', image: 'logo hana bank.png' },
        { id: 6, name: 'Client 7', image: 'hartech.png' },
        { id: 7, name: 'Client 8', image: 'logo interpan.png' },
        { id: 8, name: 'Client 9', image: 'shilin.png' },
        { id: 9, name: 'Client 10', image: 'logo yumeida.png' },
        { id: 10, name: 'Client 11', image: 'logo ABC.png' },
        { id: 11, name: 'Client 12', image: 'pupuk logistik.webp' },
        { id: 12, name: 'Client 13', image: 'Logo SIM.jpg' },
        { id: 13, name: 'Client 14', image: 'logo gvs.png' },
        { id: 14, name: 'Client 15', image: 'logo rossy.jpeg' },
        { id: 15, name: 'Client 16', image: 'logo tea garden.png' },
        { id: 16, name: 'Client 17', image: 'logo cop buntut.png' },
      ]
    };
  },
  methods: {
    getImageUrl(image) {
      return new URL(`@/assets/${image}`, import.meta.url).href;
    }
  }
};
</script>

<style>
@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-100% / 2)); }
}

.animate-scroll {
  animation: scroll 80s linear infinite;
}

.animate-scroll:hover {
  animation-play-state: paused;
}
</style>